// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "article-video-loop-bundle-v2" + "-" + "0def38e38355cd6d6990" + ".css";
};